import { usePaginatedQuery, useUrlPaginatedQuery } from "@shared/hooks";
import type { PaginatedQueryParams } from "@shared/api";
import { axiosGetData } from "@shared/api/clients";
import { useQuery } from "@tanstack/react-query";

import {
  AdminUserDetailResponse,
  AdminUserFilters,
  ListAdminUsersResponseItem,
} from "./adminUsers.types";

const ADMIN_USERS_ENDPOINT = "v1/admin/users";
const ADMIN_USERS_QUERY_KEY = ["admin", "users"];
const ADMIN_USERS_FILTER_KEYS: (keyof AdminUserFilters)[] = [
  "name",
  "email",
  "sortBy",
  "sortOrder",
];

export const useAdminUsersQuery = (
  params?: PaginatedQueryParams<AdminUserFilters>,
) => {
  return usePaginatedQuery<ListAdminUsersResponseItem, AdminUserFilters>({
    endpoint: ADMIN_USERS_ENDPOINT,
    queryKeyBase: ADMIN_USERS_QUERY_KEY,
    params,
  });
};

export const useAdminUsersUrlQuery = () => {
  return useUrlPaginatedQuery<ListAdminUsersResponseItem, AdminUserFilters>({
    endpoint: ADMIN_USERS_ENDPOINT,
    queryKeyBase: ADMIN_USERS_QUERY_KEY,
    filterKeys: ADMIN_USERS_FILTER_KEYS,
  });
};

export const getAdminUser = async (
  id: string,
): Promise<AdminUserDetailResponse> => {
  return axiosGetData<AdminUserDetailResponse>(
    `${ADMIN_USERS_ENDPOINT}/${id}`,
  );
};

export const useAdminUserQuery = (id: string, options = {}) => {
  return useQuery({
    queryKey: [...ADMIN_USERS_QUERY_KEY, id],
    queryFn: () => getAdminUser(id),
    enabled: !!id,
    ...options,
  });
};
